<template>
<div>
    <m-edit-date
        label="Start Date"
        v-model="start_date"
    />

    <m-edit-date
        label="End Date"
        v-model="end_date"
    />

    <v-chip
        style="margin-right: 15px"
        v-on:click="onClickLastMonth"
    >
        Last Month
    </v-chip>

    <v-chip
        v-on:click="onClickThisMonth"
    >
        This Month
    </v-chip>

    <div
        style="text-align: right"
    >
        <v-btn
            color="primary"
            v-on:click="onClickExport"
        >
            Export
        </v-btn>
    </div>

    <p
        style="margin-top: 15px"
    >
        <b>Important Note</b>:  Amounts shown on the utilization report may deviate slightly from the utilization appearing on your invoice(s).  The carriers provide us with reconcillations that better account for errors and other unusual circumstances.  From time to time these reconciliations will change your organization's utilization.
    </p>
</div>
</template>

<script>
const Time = require('@/js/time.js');

export default {
    props: {
        profile: {
            type: Object,
            default: function() { return {}; }
        },
    },

    data() {
        return {
            start_date: null,
            end_date: null,
        }
    },

    mounted () {
        this.onClickThisMonth();
    },

    methods: {
        onClickThisMonth() {
            this.start_date = Time.toISOFirstDayOfMonth(new Date());
            this.end_date = Time.toISOLastDayOfMonth(new Date());   
        },

        onClickLastMonth() {
            let last_month = new Date();
            last_month.setDate(1);
            last_month.setMonth(last_month.getMonth()-1);

            this.start_date = Time.toISOFirstDayOfMonth(last_month);
            this.end_date = Time.toISOLastDayOfMonth(last_month);   
        },

        onClickExport()
        {
            this.$rc.excelExport(
                    'EXPORT: /api/v1/utilization-report',
                    {
                        'organization_id': this.profile.organization_id,
                        'start_date' : this.start_date,
                        'end_date' : this.end_date,
                    }
                );
        }
    },
}
</script>

<style lang="scss" scoped>

</style>